/**
 * Which guard blocks a contour-geometry edit: a signed-off DICOM approval,
 * or the self-service viewer-side lock. Shared by engine and UI so every
 * refusal names the same cause.
 */
export type ContourEditBlocker = 'approval' | 'lock';

/**
 * Approval outranks the lock: on an approved+locked ROI, reporting "locked"
 * would suggest a remedy (unlock) that cannot work and present the edit lock
 * as standing in for the DICOM review. Undefined = nothing blocks.
 */
export function resolveContourEditBlocker(
    isApproved: boolean,
    isLocked: boolean
): ContourEditBlocker | undefined {
    if (isApproved) {
        return 'approval';
    }
    return isLocked ? 'lock' : undefined;
}
